import { createTheme } from "@mui/material/styles";

const palette = {
  primary: {
    main: "#e6352b",
    light: "#f5d9d7",
    dark: "#f18d88",
  },
  secondary: {
    main: "#5eaee6",
    light: "#c8e4f7",
    dark: "#0679c9",
  },
  black: "#363636",
};

const theme = createTheme({
  palette: palette,
  components: {
    MuiInputBase: {
      variants: [
        {
          props: { variant: "secondary" },
          style: {
            backgroundColor: palette.secondary.light
          },
        },
      ],
    },
    MuiPaper: {
      variants: [
        {
          props: { variant: "secondary" },
          style: {
            backgroundColor: palette.secondary.light,
            border: `1px solid ${palette.secondary.main}`
          },
        },
      ],
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '1rem',
          textAlign: 'center',
          padding: '1rem'
        }
      }
    },

  },
});

//TODO: figure this out with mui styled
export const TextFieldRightAligned = {inputProps:{style: { textAlign: 'right' }}};

export default theme;
